<template>
    <div>
        <el-dialog title="服务协议" :visible.sync="agreement.visible" width="70%">
            <iframe v-if="agreement.data" :src="agreement.data.content" seamless width="100%" height="600px"></iframe>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeAgreementDialog">取消</el-button>
                <el-button type="primary" @click="submitAgreementForm">同意</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    name: 'Agreement',
    data() {
        return {
            agreement: {
                visible: false,
                data: {
                    id: 0,
                    content: '',
                    is_affect: false,
                }
            }
        }
    },
    computed: {
        user() {
            return window.USER;
        }
    },
    methods: {
        async getAgreement() {
            try {
                const res = await axios.get('/api/src/user/agreement/latest');
                this.agreement.data = res.data["agreement"];
            } catch (err) {
                console.error(err);
            }
        },
        closeAgreementDialog() {
            this.agreement.visible = false;
        },
        async submitAgreementForm() {
            try {
                await axios.post('/api/src/user/agreement/agree', {
                    id: this.agreement.data.id,
                });
                window.USER.lastAgreementId = this.agreement.data.id;
                this.agreement.visible = false;
            } catch (err) {
                console.error(err);
            }
        }
    },
    mounted() {
        setTimeout(async () => {
            await this.getAgreement();
            if (this.user && this.user.lastAgreementId !== this.agreement.data.id && this.agreement.data.is_affect) {
                this.agreement.visible = true;
            }
        }, 1000)
    }
}
</script>

<style lang="scss"></style>